// extracted by mini-css-extract-plugin
export default {"products":"_s-z","card":"at-z","oosMessaging":"bt-z"};